"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _line = require("@nivo/line");
var _index = require("./index");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("../../utils/constants");
var _ChartParams = require("../../features/provider/ChartParams");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const MemoLineChartContent = _ref => {
  let {
    data,
    rangeType,
    dateType,
    isPrediction = false,
    activeLinePosition,
    setActiveLine,
    yScale = null,
    y1Axis = true,
    y2Axis = false,
    unit = null,
    enableGridY = true,
    withTitle = true,
    curve = _constants.curveTypes.catmullRom,
    withAxesBottom = true,
    showTooltip = false
  } = _ref;
  const {
    isDynamicHeight
  } = (0, _ChartParams.useChartParams)();

  /** @todo remove useMemo */
  return (0, _react.useMemo)(() => {
    const markers = data.length ? data.map((d, i) => _objectSpread(_objectSpread({}, markerStyle), {}, {
      value: (0, _index.getPositionForTitle)(data, i),
      legend: data[i] ? data[i].title : ""
    })) : [];
    const todayMarker = {
      axis: "x",
      value: new Date((0, _moment.default)().hour(0).format("MM/DD/YYYY")),
      lineStyle: {
        stroke: "#0000FF",
        strokeWidth: 2,
        opacity: isPrediction ? 1 : 0
      },
      legend: "today",
      textStyle: {
        transform: "translate(-20px, -20px) rotate(0deg)",
        fill: "#240bff",
        opacity: isPrediction ? 1 : 0
      }
    };
    const getMarkers = data.length > 1 && data[0].data.length ? [...markers, todayMarker] : [...(data.length && data[0].data.length ? [markers[0]] : []), todayMarker];
    const getColor = () => {
      return data.map(d => d.transparent ? "rgba(255, 255, 255, 0)" : d.color);
    };
    const defaultYScale = {
      type: "linear",
      stacked: false,
      reverse: false,
      min: (0, _ChartParams.getHeightByFlag)({
        isDynamicHeight,
        value: 0
      }),
      max: (0, _ChartParams.getHeightByFlag)({
        isDynamicHeight,
        value: _constants.maxWaterTemperature
      })
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_line.ResponsiveLine, {
      data: data,
      theme: _index._lineTheme,
      margin: {
        top: 35,
        right: withTitle ? 215 : 68,
        bottom: 60,
        left: 68
      },
      colors: getColor() /* Make the first line transparent with 0 opacity */,
      layers: ["grid", p => /*#__PURE__*/_react.default.createElement(_index.PredictionZone, _extends({}, p, {
        isPrediction: isPrediction
      })), "markers", _index.EmptyZoneMesh, "areas", "lines", "slices", "axes", "points", "crosshair", () => /*#__PURE__*/_react.default.createElement(_index.ActiveLine, {
        activeLinePosition: activeLinePosition
      }), "mesh"],
      sliceTooltip: d => {
        if (d) setActiveLine === null || setActiveLine === void 0 || setActiveLine(d);
        return null;
      }
      // tooltip={({point = {}}) => {
      //     const title = data.find(item => item.id === point.serieId)?.title || '';
      //     return (
      //         <div className={`flex-column line-chart-tooltip-value`}>
      //             {dateType !== 'year' ?
      //                 < span className={'date'}>
      //                         <Moment format={'HH:mm MMM DD'}>
      //                             {point?.data?.x || '-'}
      //                         </Moment>
      //                     </span> : null}
      //             <span>{title}</span>
      //             <span>{point.data ? `${point.data.y.toFixed(0)} °C` : '-'}</span>
      //         </div>
      //     )
      // }}
      ,
      markers: withTitle ? getMarkers : [todayMarker],
      xFormat: "time:%Y-%m-%d",
      xScale: {
        type: "time",
        format: "%Y-%m-%d %H:%M",
        useUTC: false,
        precision: _constants.rangeTypesByKey[rangeType]
      },
      yFormat: " >-.1f",
      yScale: yScale || defaultYScale,
      curve: curve,
      axisTop: withAxesBottom ? {
        format: t => (0, _index.getTimeFormatTitle)(t, rangeType, dateType),
        orient: "bottom",
        tickSize: 0,
        tickPadding: 0,
        tickRotation: 0
      } : null,
      axisBottom: withAxesBottom ? {
        format: t => (0, _index.getTimeFormat)(t, rangeType, dateType),
        orient: "bottom",
        tickSize: 0,
        tickPadding: 10,
        tickRotation: 0,
        tickValues: dateType === "month" ? "every ".concat(window.innerWidth < 1500 ? 2 : 1, " days") : undefined
      } : null,
      axisLeft: y1Axis ? {
        format: value => "".concat(value, " ").concat(unit ? unit : ""),
        orient: "left",
        tickSize: 0,
        tickPadding: 18,
        tickRotation: 0
      } : null,
      axisRight: y2Axis ? {
        format: value => "".concat(value, " ").concat(unit ? unit : ""),
        orient: "right",
        tickSize: 0,
        tickPadding: 18,
        tickRotation: 0
      } : null,
      enableGridX: false,
      lineWidth: 1,
      enablePoints: false,
      areaOpacity: 0.05,
      enableSlices: "x",
      crosshairType: "bottom",
      useMesh: true,
      animate: false,
      enableGridY: enableGridY
    }));
  }, [data, rangeType, dateType, /*rules, setXScale, setYScale,*/isPrediction, yScale, activeLinePosition.x, activeLinePosition.y, isDynamicHeight, setActiveLine]);
};
const markerStyle = {
  axis: "y",
  lineStyle: {
    strokeWidth: 0
  },
  legendPosition: "right",
  textStyle: {
    fill: "#00205B",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "inherit"
  }
};
const MultiChart = props => {
  const {
    data,
    rangeType,
    dateType,
    setActive,
    isPrediction,
    inProgress,
    setInProgress,
    yScale,
    y1Axis,
    y2Axis,
    unit,
    enableGridY,
    withTitle,
    curve = _constants.curveTypes.catmullRom,
    withAxesBottom = true,
    showTooltip = false
  } = props;
  const [activeLine, setActiveLine] = (0, _react.useState)(null);
  /** @todo maybe that's wrong */
  (0, _react.useEffect)(() => {
    if (data.length) {
      setActiveLine(null);
      setInProgress(false);
    }
  }, [data]);
  (0, _react.useEffect)(() => {
    if (activeLine) setActive(activeLine);
  }, [activeLine]);
  const activeLinePosition = {
    x: activeLine === null || activeLine === void 0 ? void 0 : activeLine.slice.x,
    y: activeLine === null || activeLine === void 0 ? void 0 : activeLine.slice.height
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-100 position-absolute nivo-line-chart-points"
  }, /*#__PURE__*/_react.default.createElement(MemoLineChartContent, {
    data: inProgress ? [] : data,
    rangeType: rangeType,
    dateType: dateType,
    isPrediction: isPrediction,
    activeLinePosition: activeLinePosition,
    setActiveLine: setActiveLine,
    yScale: yScale,
    y1Axis: y1Axis,
    y2Axis: y2Axis,
    unit: unit,
    enableGridY: enableGridY,
    withTitle: withTitle,
    curve: curve,
    withAxesBottom: withAxesBottom
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "tooltip",
    className: "pointer-event-none line-chart-tooltip-info"
  }));
};
var _default = exports.default = MultiChart;